import { Modal } from "flowbite-react"
import FormCreateCategory from "../form/FormCreateCategory"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import { createCategory } from "../../../../common/services/category.api"

type Props = {
  onClose?: () => void
}

export default function ModalCreateCategory(props: Props) {
  const { notifySuccess, notifyError } = useToastContext()

  const handleCloseModal = () => { props.onClose && props.onClose() }

  async function handleSubmit(dataToSave) {
    try {
      const result = await createCategory(dataToSave)

      if (!result.ok) {
        notifyError(result.message as string)
      }
      handleCloseModal();
      notifySuccess(`Categoria "${(result.data as { name: string }).name}" cadastrada!`)
    } catch (err) {
      console.log(err)
      notifyError((err as Error).message as string)
    }
  }

  return (
    <Modal
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'><h2 className='text-black'>{'Nova categoria'}</h2></Modal.Header>
      <Modal.Body className='text-black'>
        <FormCreateCategory onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  )
}